<template>
  <div>
    <div class="mb-8">
      <app-title size="middle" weight="bold" class="mb-4">{{
        $t('companyDemoMetadata.title')
      }}</app-title>
      <p v-dompurify-html="$t('companyDemoMetadata.description')"></p>
      <p class="grey--text">{{ $t('companyDemoMetadata.note') }}</p>
    </div>
    <v-card v-for="(test, index) in tests" :key="index" flat color="info" class="mb-2">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="8">
            <app-title size="default" classes="mb-2">{{ test.title }}</app-title>
            <p class="grey--text">{{ test.description }}</p>
          </v-col>
          <v-col cols="12" sm="auto" class="ms-auto">
            <v-btn
              block
              small
              :outlined="$vuetify.breakpoint.mobile"
              :text="!$vuetify.breakpoint.mobile"
              color="blue"
              @click="openDemoTestingDialog(test)"
            >
              <v-icon left v-text="'mdi-arrow-right'"></v-icon>
              <span>{{ $t('companyDemoMetadata.testExampleButton') }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <app-demo-testing-personal-dialog
      :is-visible="isDialogVisible.demoTestingPersonal"
      :test="selectedTest"
      @toggle-visible="toggleVisibleDialog"
    />
  </div>
</template>

<script>
import {dialogsMixin} from '@/mixins/dialogs';

import AppDemoTestingPersonalDialog from '@/components/pages/company/demo/personal-tests/dialogs/DemoTestingPersonalDialog';

export default {
  name: 'AppCompanyDemoPersonalTests',
  components: {
    AppDemoTestingPersonalDialog,
  },
  mixins: [dialogsMixin],
  data() {
    return {
      tests: [
        {
          title: this.$t('companyDemoMetadata.testsTitle.critical'),
          description: this.$t('companyDemoMetadata.testsDescription.critical'),
          href: 'https://client.maintest.ru/m-tests/?t=f207503515ff05f4',
        },
        {
          title: this.$t('companyDemoMetadata.testsTitle.burnout'),
          description: this.$t('companyDemoMetadata.testsDescription.burnout'),
          href: 'https://client.maintest.ru/m-tests/?t=b10504ba82be046b',
        },
        {
          title: this.$t('companyDemoMetadata.testsTitle.frontStaff'),
          description: this.$t('companyDemoMetadata.testsDescription.frontStaff'),
          href: 'https://client.maintest.ru/m-tests/?t=6dc75cd551d80fa6',
        },
        {
          title: this.$t('companyDemoMetadata.testsTitle.leadFive'),
          description: this.$t('companyDemoMetadata.testsDescription.leadFive'),
          href: 'https://client.maintest.ru/m-tests/?t=5c584774dba44b94',
        },
        {
          title: this.$t('companyDemoMetadata.testsTitle.personalFactor'),
          description: this.$t('companyDemoMetadata.testsDescription.personalFactor'),
          href: 'https://client.maintest.ru/m-tests/?t=ee8e17811ff0dc8f',
        },
        {
          title: this.$t('companyDemoMetadata.testsTitle.bigFive'),
          description: this.$t('companyDemoMetadata.testsDescription.bigFive'),
          href: 'https://client.maintest.ru/m-tests/?t=4b105c67455a8ad8',
        },
        {
          title: this.$t('companyDemoMetadata.testsTitle.safetyStart'),
          description: this.$t('companyDemoMetadata.testsDescription.safetyStart'),
          href: 'https://client.maintest.ru/m-tests/?t=33fa000cd26f25b3',
        },
        {
          title: this.$t('companyDemoMetadata.testsTitle.leaderCase'),
          description: this.$t('companyDemoMetadata.testsDescription.leaderCase'),
          href: 'https://client.maintest.ru/m-tests/?t=039f5121a92dc327',
        },
        {
          title: this.$t('companyDemoMetadata.testsTitle.deMetrics'),
          description: this.$t('companyDemoMetadata.testsDescription.deMetrics'),
          href: 'https://client.maintest.ru/m-tests/?t=cefa786389519352',
        },
      ],
      isDialogVisible: {
        demoTestingPersonal: false,
      },
      selectedTest: {},
    };
  },
  methods: {
    openDemoTestingDialog(test) {
      this.selectedTest = test;
      this.toggleVisibleDialog({name: 'demoTestingPersonal', state: true});
    },
  },
};
</script>
